
  <template>
  <div id="History-File">
    <b-container fluid>
      <b-row class="mb-1 text-left">
        <b-col >
          <h1 class="labelBold">{{ this.$t(`sideBar.mobileStiva.title`) }}</h1>
        </b-col>
      </b-row>
      <br/>
      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">
            <b-col sm="2" lg="2" style="background-color:white;">
              <div class="dateInput">
                <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_from") }}</label>
                <br>
                <date-picker class="dateInput" v-model="dates.from" placeholder="YYYY/MM/DD" value-type="format" format="YYYY-MM-DD" >
                </date-picker>
                <vue-timepicker v-model="schedulefrom"></vue-timepicker>
                <div v-if="$v.dates.from.$error" class="error-msg">
                  <!-- <p v-if="!$v.dates.from.required">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p> -->
                  <p v-if="!$v.dates.from.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_from")}}{{$t("bookingTransport.required")}}</p>
                  <p v-if="!$v.dates.from.InvalidDate">{{$t("mobileStiva.notCreateMobile")}}</p>
                </div>
              </div>
            </b-col>
            <b-col sm="2" lg="2"  style="background-color:white;">
              <div class="dateInput">
                <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_to") }}</label>
                <br>
                <date-picker class="dateInput" v-model="dates.to" placeholder="YYYY/MM/DD" value-type="format" format="YYYY-MM-DD" >
                </date-picker>
                <vue-timepicker v-model="scheduleto"></vue-timepicker>
                <div v-if="$v.dates.to.$error" class="error-msg">
                  <!-- <p v-if="!$v.dates.to.required">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p> -->
                  <p v-if="!$v.dates.to.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_to")}}{{$t("bookingTransport.required")}}</p>
                </div>
              </div>
            </b-col>
            <b-col  sm="4" lg="4" >
                <div class="container-input">
                  <input type="file" name="file-2" id="file-2" class="inputfile inputfile-2" @change="loadCSV($event)" accept=".csv" data-multiple-caption="{count} archivos seleccionados" multiple />
                  <label for="file-2">
                    <i style='font-size:24px' class='fas'>&#xf6dd;</i>
                    <span class="iborrainputfile" id="filecsv"> {{ $t("users.search.selectFile") }}</span>
                  </label>
                  <div v-if="errorFile">
                    <i style='font-size:24px; float:right;' class='fas btn-outline-secondary' @click="removeFile()">&#xf1f8;</i>
                  </div>
                </div>
            </b-col>
          <b-col  sm="4" lg="4">
            <div v-if="BadDate">
              <button class="btn-confirm-date btn-outline-secondary" @click="SaveMobileStiva">
                {{ $t("mobileStiva.createMobile") }}
                <i style='font-size:18px' class='fas'>&#xf0c7;</i>
              </button>
            </div>
        </b-col>
      </b-row>
    </b-container>
    <div class="row">
      <div class="col-md-12">
        <v-server-table :columns="table_options_mobileStiva.columns" :options="table_options_mobileStiva.options" ref="mobileStiba" id="mobileStiba">
         <!-- <template v-slot:actions="props">
            <center><i style='font-size:24px' class='fas btn-outline-primary' @click="Dowload(props.row.id)">	&#xf019;</i></center>
          </template> -->
            <template v-slot:actions="props">
              <center>
               <i style='font-size:24px' class='fas btn-outline-dark' @click="csvReport(props.row)">&#xf56d;</i>
              </center>
            </template>
          <template #status = "props"> {{Status(props.row.status)}}</template>
          <template #controlNumber="props">{{translateStatus(props.row.user)}}</template>
          <template #createdAt="props">{{props.row.createdAt | formatDateOnly(appLang)}}</template>
          <template #dateFrom="props">{{props.row.dateFrom | formatDateOnly(appLang)}}</template>
          <template #dateTo="props">{{props.row.dateTo | formatDateOnly(appLang)}}</template>
        </v-server-table>
      </div>
    </div>

    <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">

      <b-col  sm="11" lg="11" >
      </b-col>
      <b-col  sm="1" lg="1" >
        <div v-if="showDowload">
          <download-excel
            id="excelDescarga"
            class="btn-confirm"
            :data="ArrayReport"
            :fields = "json_fields"
            :aria-modal="json_meta"
            type="csv"
            worksheet="My Worksheet"
            :name="namefile">
          </download-excel>
        </div>
      </b-col>
    </b-row>
    <b-modal size="lg" centered ref="my-error" hide-footer scrollable :title="$t('bookingTransport.errorUpload')" tabindex="-1" >
      <div>
       <textarea v-model="ErroresStiva" class="form-control" rows="15">
       </textarea>
      </div>
     <!-- <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DowloadLayout()">
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template> -->
    </b-modal>
  </div>
  </template>
<script>
import { required } from "vuelidate/lib/validators";

import Vue from "vue";
import JsonExcel from "vue-json-excel";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";
import MobileStiva from "@/lib/api/MobileStiva";
const api = new MobileStiva();
Vue.component("downloadExcel", JsonExcel);



import moment from "moment-timezone";

export default {

  components: {
    DatePicker,
    VueTimepicker
  },

  data() {
    return {
      params: null,
      BadDate:false,
      errorFile:false,
      formData:null,
      validateDate:null,
      scheduleto: {
        HH: "23",
        mm: "59"
      },
      schedulefrom: {
        HH: "00",
        mm: "00"
      },
      showDowload:true,
      filters: [],
      sortOrders:{},
      parse_header:[],
      ErroresStiva:"",
      namefile:"",
      dates:
        {
          from: "",
          to: "",
        },
      ArrayReport:[],
      ArrayMobile: [
        {
          "UID":"DZM4JW5",
          "PASSWORD":"uY8.J--X5D6C",
          "NAME":"Javier Hernández",
          "GIVENNAME":"Arenas Varela",
          "EMPLOYEENO":"837265"

        },
        {
          "UID":"DZM4JW5",
          "PASSWORD":"uY8.J--X5D6C",
          "NAME":"Javier Hernández",
          "GIVENNAME":"Arenas Varela",
          "EMPLOYEENO":"837265"
        }],

      json_fields: {
        Compania:"﻿Compañía ",
        UID: "UID",
        PASSWORD: "PASSWORD",
        SALUTATION:"SALUTATION",
        NAME: "NAME",
        GIVENNAME: "GIVENNAME",
        EMPLOYEENO: "EMPLOYEENO",
        COSTCENTER:"COSTCENTER",
        SUBDEPARTMENT: "SUBDEPARTMENT",
        GID:"GID",
        LANGUAGE:"LANGUAGE",
        EMAIL:"EMAIL",
        TYPE:"TYPE "
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "ISO-8859-1",
          },
        ],
      ],


    }
  },

  validations: {
    dates: {
      from: {
        required,
        InvalidDate: function (Planning) {
          // var fecha = new Date().toISOString().slice(0, 10);
          var fecha = new Date();
          var ValFecha = moment(fecha).format('YYYY-MM-DD');
          if (Planning >= ValFecha) {
            return true;
          } else {
            return false;
          }
        }
      },
      to: {
        required
      }
    }
  },

  methods: {

    //timeoutController() {
      //setTimeout(function() {
        //console.log("Entra")
        //this.$store.commit("global/SET_ALERT", {
          //msg: "Archivo descargado con éxito",
         // show: true,
          //type: "success"
        //});
      //}, 1000);
    //},

    Status (status) {

      if (status == "loading"){
        status = "Cargando"
      }
      else if(status == "loaded"){
        status = "Cargado"
      }
      else if(status == "failed"){
        status =  "Error"
      }
      else {
        status
      }
      return status
    },

    UpdatemobileStibaTable: function() {
      this.mobileStiba.refresh();
    },

    SaveMobileStiva: async function () {
      try {

        this.$v.$touch();
        if (this.$v.$error) return;
        this.$store.commit("global/SET_LOADING", true);




        if (this.schedulefrom != null || this.schedulefrom != "") {
          if(this.schedulefrom.HH == "" || this.schedulefrom.mm == "") {

            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: "Selecciona un horario", //`${this.$t("mobilityOnDemand.rango")}`,
              show: true,
              type: "error"
            });
            return;
          }
        }

        if (this.scheduleto != null || this.scheduleto != "") {
          if(this.scheduleto.HH == "" || this.scheduleto.mm == "") {

            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: "Selecciona un horario", //`${this.$t("mobilityOnDemand.rango")}`,
              show: true,
              type: "error"
            });
            return;
          }
        }

        if (this.dates.to < this.dates.from) {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;
        }
        if (this.schedulefrom == null || this.scheduleto == null) {
          console.log(this.schedulefrom);
          console.log(this.scheduleto);
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Valide Horarios", //`${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;
        } else {
          const horafrom = this.schedulefrom.HH + ":" + this.schedulefrom.mm;
          const horato = this.scheduleto.HH + ":" + this.scheduleto.mm;
          //const getDate = (type = "from") => {
            //const time = type === "from" ? "T" + horafrom  : "T" + horato ;
            //return `${this.dates[type]}${time}`;
          //};


          this.params = {
            dateFrom: moment.tz(this.dates.from+"T"+horafrom,"America/Mexico_City").utc().format(),
            dateTo: moment.tz(this.dates.to+"T"+horato,"America/Mexico_City").utc().format()
          };

          const validate = await api.validateDates(this.params);
          this.validateDate = validate.hasUploadedFilesInPeriod;

          if (this.validateDate == true) {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: "Ya existen credenciales para una encuesta de Stimmungsbarommeter para el rango de fechas seleccionado",
              show: true,
              type: "error"
            });
            this.BadDate = true;

          }

           else {
            this.formData.append('dateFrom', this.params.dateFrom);
            this.formData.append('dateTo', this.params.dateTo);
            const resp = await api.UploadStiba(this.formData);
            console.log(resp);
            this.UpdatemobileStibaTable();
            this.errorFile = false;
            document.getElementById("file-2").value = "";
            document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");
            this.BadDate = false;
            this.schedulefrom.HH = "00"
            this.schedulefrom.mm = "00"
            this.scheduleto.HH = "23"
            this.scheduleto.mm = "59"
            var fecha = new Date();
            var ValFecha = moment(fecha).format('YYYY-MM-DD');
            this.dates.from = ValFecha;
            this.dates.to = ValFecha + 30;
            this.UpdatemobileStibaTable();
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: "El archivo se ha subido con éxito",
              show: true,
              type: "success"
            });
          }
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: "Hubo un error al cargar el archivo, inténtalo de nuevo más tarde.",
          show: true,
          type: "error"
        });
      }
  },
    removeFile: function () {
      try{
        this.errorFile = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.delete"),
          show: true,
          type: "success"
        });
      }
      catch(error){

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: "Hubo un error al cargar el archivo, inténtalo de nuevo más tarde.",
          show: true,
          type: "error"
        });

      }
    },
    translateStatus (data) {
      return data.fullname;
    },
    csvReport: async function(row){
      try {
        this.$store.commit("global/SET_LOADING", true);
        var fecha = new Date();
        var ValFecha = moment(fecha).format('YYYY-MM-DD');//"2024-10-01"//
        var Dateexpire = moment(row.expiresAt).format('YYYY-MM-DD');//"2023-09-01"//

        const FechaYear1 = parseInt(ValFecha.split('-')[0])
        const FechaMonth1 = parseInt(ValFecha.split('-')[1])
        const expireYear2 = parseInt(Dateexpire.split('-')[0])
        const expireMonth2 = parseInt(Dateexpire.split('-')[1])
        var months;
        months = (FechaYear1-expireYear2) * 12;
        months -= FechaMonth1;
        months += expireMonth2;
        var number1months = months <= 0 ? 0 : months;
        if(number1months == 11 ){
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Por políticas de almacenamiento este archivo ha sido eliminado después de 11 meses",
            show: true,
            type: "error"
          });
          return;
        }



        const resp = await api.downloadS3Report(row.id);

        console.log(resp);
        let anchor = document.createElement("a");
        anchor.href = resp.url;
        anchor.target = "_blank";
        anchor.click();
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: `${this.$t("mobilityOnDemand.dowloadSuccess")}`,
          show: true,
          type: "success"
        });

        return;

      const csv = await api.dowloadFile(row.id);

        console.log(csv);
      var vm = this
      var lines = csv.split("\n")
      var result = []
      var headers = lines[0].split(",")
      vm.parse_header = lines[0].split(",")
      lines[0].split(",").forEach(function (key) {
        vm.sortOrders[key] = 1
      })
      lines.map(function(line, indexLine){
        if (indexLine < 1) return // Jump header line
        var obj = {}
        var currentline = line.split(",")
        headers.map(function(header, indexHeader){
          obj[header] = currentline[indexHeader]
        })
        result.push(obj)
      })
      result.pop(); // remove the last item because undefined values
      this.ArrayReport = result;
      this.namefile = row.filename;
      var currentDiv = currentDiv = document.getElementById("excelDescarga");
      setTimeout(function(){
        currentDiv.click();
      }, 10);
        //this.timeoutController();
        setTimeout(function () {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Archivo descargado con éxito",
            show: true,
            type: "success"
          }); }.bind(this), 5000)

      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },


    startDownload(){
      this.$store.commit("global/SET_LOADING", false);
      this.$store.commit("global/SET_ALERT", {
        msg:"Descargando..",//`${this.$t("mobilityOnDemand.rango")}`,
        show: true,
        type: "success"
      });

    },
    finishDownload(){
      this.$store.commit("global/SET_LOADING", false);
      this.$store.commit("global/SET_ALERT", {
        msg:"Archivo descargado con éxito",//`${this.$t("mobilityOnDemand.rango")}`,
        show: true,
        type: "success"
      });
    },

    async fetchData(id){

      try {
        this.$store.commit("global/SET_LOADING", true);
        var currentDiv = document.getElementById("excelDescarga");
        currentDiv.click();
        const resp = await api.dowloadFile(id);
        console .log(resp)
        //var stringToJsonObject = JSON.stringify(resp.items);
        this.$store.commit("global/SET_LOADING", false);
        return this.ArrayMobile;

        this.json_data = resp.items;
        this.descarga = false;
        this.$store.commit("global/SET_LOADING", false);
        return resp.items;


      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    Dowload: async function(id){
      try {

          const resp = await api.dowloadFile(id);
          console .log(resp)
          return;
          let anchor = document.createElement("a");
          anchor.href = resp;
          anchor.target = "_blank";
          anchor.click();
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("openToMove.SuccessDowload")}`,
            show: true,
            type: "success"
          });

      }

      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },


    loadCSV: async function(e){
      try {

        this.$store.commit("global/SET_LOADING", true);
        this.$v.$touch();
        if (this.$v.$error) {
          this.$store.commit("global/SET_LOADING", false);
          return;
        } else{
        //document.getElementById("file-2").value = "";
        //document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

        this.$store.commit("global/SET_LOADING", true);


        if (this.dates.to== "" || this.dates.from =="") {

          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Ingrese Fechas", //`${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;
        }

        if (this.dates.to== null|| this.dates.from ==null) {

          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Ingrese Fechas", //`${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;
        }
         if (this.schedulefrom != null || this.schedulefrom != "") {
         if(this.schedulefrom.HH == "" || this.schedulefrom.mm == "") {


           this.$store.commit("global/SET_LOADING", false);
           this.$store.commit("global/SET_ALERT", {
             msg: "Selecciona un horario", //`${this.$t("mobilityOnDemand.rango")}`,
             show: true,
             type: "error"
           });

           document.getElementById("file-2").value = "";
           document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

           return;
         }
        }

        if (this.scheduleto != null || this.scheduleto != "") {
          if(this.scheduleto.HH == "" || this.scheduleto.mm == "") {

            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: "Selecciona un horario", //`${this.$t("mobilityOnDemand.rango")}`,
              show: true,
              type: "error"
            });
            return;
          }
        }


        if (this.dates.to < this.dates.from) {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;
        }
        if (this.schedulefrom == null || this.scheduleto == null) {

          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Valide Horarios", //`${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;
        } else {
          const horafrom = this.schedulefrom.HH + ":" + this.schedulefrom.mm;
          const horato = this.scheduleto.HH + ":" + this.scheduleto.mm;
          const getDate = (type = "from") => {
            const time = type === "from" ? "T" + horafrom + "-06:00" : "T" + horato + "+00:00";
            return `${this.dates[type]}${time}`;
          };
          this.params = {
            dateFrom: moment.tz(this.dates.from+"T"+horafrom,"America/Mexico_City").utc().format(),
            dateTo: moment.tz(this.dates.to+"T"+horato,"America/Mexico_City").utc().format()
          };
          const validate = await api.validateDates(this.params);
          this.validateDate =   validate.hasUploadedFilesInPeriod;
         // if (validate.status(400)) {
          //  console.log(validate);
          // this.$store.commit("global/SET_LOADING", false);
          // this.$store.commit("global/SET_ALERT", {
          //   msg: validate,
          //   show: true,
          //   type: "error"
          // }); }
          var vm = this
          if (window.FileReader) {
            /*
        const mime = require("mime");
        mime.getType("csv");
        mime.getType(e.target.files[0].name);
        mime.getType(e.target.files[0]);
        mime.getExtension("text/csv");
        console.log(mime);
        let data = new FormData();
        let file = e.target.files[0];
        data.append('name', e.target.files[0].name)
        data.append('file', file)
        console.log(data);*/


            // const fileField1 = document.getElementById('filecsv');
            this.formData = new FormData();
            this.formData.append('credentials', e.target.files[0]);
            this.formData.append('controlNumber', this.$store.getters["session/userControl"]);

            var reader = new FileReader();
            reader.readAsText(e.target.files[0]);
            document.getElementById('filecsv').textContent = e.target.files[0].name;
            reader.onload = function (event) {
              var csv = event.target.result;
              vm.parse_csv = vm.csvJSON(csv)
            };
            reader.onerror = function (evt) {
              if (evt.target.error.name == 'NotReadableError') {
                this.$store.commit("global/SET_ALERT", {
                  msg: "Cannot read File !",
                  show: true,
                  type: "error"
                });
              }
            };
          } else {
            this.$store.commit("global/SET_ALERT", {
              msg: "FileReader are not supported in this browser",
              show: true,
              type: "error"
            });
          }
          this.$store.commit("global/SET_LOADING", false);
        }
        }
      }
    catch (error) {

      console.log(error);
      this.$store.commit("global/SET_LOADING", false);
      this.$store.commit("global/SET_ALERT", {
        msg: "Hubo un error al cargar el archivo, inténtalo de nuevo más tarde.",
        show: true,
        type: "error"
      });
      }
    },


    csvJSON: async function(csv) {

      try{

      var vm = this

      var lines = csv.split("\n")
      var result = []
      var headers = lines[0].split(",")
      var encabezado = JSON.stringify(headers);
      var encabezado1 = JSON.parse(encabezado);
      var validaencabezado = encabezado1.toString();//.replace(/,/g, '');
      var valida = 'Compañía,UID,PASSWORD,SALUTATION,NAME,GIVENNAME,EMPLOYEENO,COSTCENTER,SUBDEPARTMENT,GID,LANGUAGE,EMAIL,TYPE\r';

        if(validaencabezado == valida)
        {
      vm.parse_header = lines[0].split(",")
      lines[0].split(",").forEach(function (key) {
        vm.sortOrders[key] = 1
      })
      lines.map(function (line, indexLine) {
        if (indexLine < 1) return // Jump header line
        var obj = {}
        var currentline = line.split(",")
        headers.map(function (header, indexHeader) {
          obj[header] = currentline[indexHeader]
        })
        result.push(obj)
      })
      result.pop();// remove the last item because undefined values
      var UID  = "";
      var PASSWORD = "";
      var EMPLOYEENO = "";
      var GID ="";
      var fila = 1;
      var Error = false;

      this.$store.commit("global/SET_LOADING", true);
      result.forEach((data, index) => {
        fila = index + 1;
        // console.log(data.UID);
        if (data.UID == null || data.UID == "") {
          UID = UID + "," + fila;
          Error = true;
        }
        if (data.PASSWORD == null || data.PASSWORD == "") {
          PASSWORD = PASSWORD + "," + fila;
          Error = true;
        }
        if (data.EMPLOYEENO == null || data.EMPLOYEENO == "" || data.EMPLOYEENO.length < 6) {
          EMPLOYEENO = EMPLOYEENO + "," + fila;
          Error = true;
        }
        if (data.GID == null || data.GID == "") {
          GID = GID + "," + fila;
          Error = true;
        }
      })
      if(this.validateDate ==true){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: "Ya existen credenciales para una encuesta de Stimmungsbarommeter para el rango de fechas seleccionado",
          show: true,
          type: "error"
        });
        this.BadDate = true;

      }
        if(Error == true)
       {
         this.BadDate = false;
         this.$store.commit("global/SET_LOADING", false);
         this.$store.commit("global/SET_LOADING", false);
         this.$store.commit("global/SET_ALERT", {
           msg: "Uno o más registros no contienen toda la información requerida",
           show: true,
           type: "error"
         });
         this.ErroresStiva = "Filas Errores UID : " + UID +" Filas Errores PASSWORD : " + PASSWORD +" Filas Errores EMPLOYEENO : " + EMPLOYEENO+" Filas Errores GID : " + GID;
         this.errorFile = true;
         this.$refs['my-error'].show();
       }
       else{

          this.formData.append('dateFrom', this.params.dateFrom);
          this.formData.append('dateTo', this.params.dateTo);
          const resp = await api.UploadStiba(this.formData);

          console.log(resp);
          this.UpdatemobileStibaTable();



        this.errorFile = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");
        this.schedulefrom.HH = "00"
        this.schedulefrom.mm = "00"
        this.scheduleto.HH = "23"
        this.scheduleto.mm = "59"
        var fecha = new Date();
        var ValFecha = moment(fecha).format('YYYY-MM-DD');
        this.dates.from = ValFecha;
        this.dates.to = ValFecha;
        this.UpdatemobileStibaTable();
         this.$store.commit("global/SET_LOADING", false);
         this.$store.commit("global/SET_ALERT", {
           msg: "El archivo se ha subido con éxito",
           show: true,
           type: "success"
         });
       }


        }
        else{
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Uno o varios nombres de columnas no son válidos. Los nombres válidos son: Compañía, UID, PASSWORD, SALUTATION, NAME, GIVENNAME, EMPLOYEENO, COSTCENTER, SUBDEPARTMENT, GID, LANGUAGE, EMAIL y TYPE",
            show: true,
            type: "error"
          });
          this.errorFile = true;
        }

    }
    catch(ex){
      this.$store.commit("global/SET_LOADING", false);
      this.$store.commit("global/SET_ALERT", {
        msg: "Hubo un error al cargar el archivo, inténtalo de nuevo más tarde.",
        show: true,
        type: "error"
      });
    }

    }
  },

  filters: {

    formatDateOnly: function(value, lang) {
      if (!value) return '';
      if (lang === 'es') {
        moment.locale("es-do");
      } else {
        moment.locale("en");
      }
      return moment.tz(value,"America/Mexico_City").format("YYYY-MM-DD HH:mm");

      //return moment(value).format("YYYY/MM/DD hh:mm:ss"); moment(value).utcOffset(-360).format('YYYY-MM-DD hh:mm:ss')
    },

  },
  computed: {

    mobileStiba: function() {
      return this.$refs.mobileStiba;
    },


    appLang: function() {
      return this.$store.getters['settings/currentLang'];
    },

    table_mobileStiva_columns: function(){
      return [
        "filename",
        "rows",
        "controlNumber",
        "createdAt",
        "dateFrom",
        "dateTo",
        "status",
        "actions"
      ]
    },
    table_mobileStiva_headings: function() {
      if (this.table_mobileStiva_columns) {
        const headings = {};
        this.table_mobileStiva_columns.forEach(column => {
          headings[column] = this.$t(
            `mobileStiva.table_mobileStiva.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters_mobileStiva: function () {
      return this.table_mobileStiva_columns.filter((column) => column !== "actions");
    },
    table_options_mobileStiva: function () {
      return {
        columns: this.table_mobileStiva_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_mobileStiva_headings,
            filterable: false,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 25,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              created_at: "created_at"
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
            requestAdapter: function(data) {
              const queries = {};
              queries.pagination= {all:false,
                limit:data.limit,
                offset:  data.limit * (data.page-1),
              };
              queries.filter = data.query;
              queries.filter = {};
              return queries;

            },
            requestFunction: async function(data) {
              this.$store.commit("global/SET_LOADING", true);
              try {

                const resp = await api.getLists(data);
                this.$store.commit("global/SET_LOADING", false);
                 //console.log(resp);
                return resp;
              } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  msg: `${error}`,
                  show: true,
                  type: "error"
                });
                throw error;
              }
            },
            responseAdapter: function(response) {
              return {
                data: response.items,
                count: response.total
              };
            }
          },
      };
    },
  }
}
</script>
<style lang="scss">
#History-File {
  background-color: $white;
  padding: 2rem 4rem;
}
.container-input {
  text-align: center;
  background: #fff; //#b6b0b0;
  top: 30px;
  border-top: 5px solid #fff; //#000000;
  padding: 5px 0;
  border-radius: 6px;
  width: 70%;
  height: 70%;
  margin: 0 auto;
  margin-bottom: 1em;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  max-width: 100%;
  font-size: 1.35rem;
  font-weight: 200;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}
.inputfile + label i {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.05em;
}
.iborrainputfile {
  font-size:14px;
}
.inputfile-2 + label {
  color: #fff;
  background-color: #000000;
}
.inputfile-2:focus + label,
.inputfile-2.has-focus + label,
.inputfile-2 + label:hover {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #000000;
}

.btn-confirm {
  margin-left: 1rem;
  padding:1rem 1rem;
  background: #fff;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 0px;
}

.btn-confirm-date {
  margin-left: 1rem;
  padding:1rem 1rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
}

.error-msg {
  color: $warn_red;
  font-size: 14px;
}

.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown {
  float: left !important;
}

.VueTables__columns-dropdown > button {
  color: #000 !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
}
.VueTables .dropdown .dropdown-menu a {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.VueTables .dropdown .dropdown-menu a > input {
  margin-right: 0.5rem;
}
</style>

